<script setup lang="ts">
import { onLaunch, onShow } from '@dcloudio/uni-app'

onLaunch(() => {
  console.log('App Launch')
})
onShow(() => {
  console.log('App Show')
})
</script>

<style lang="scss">
/* 全局样式 */
@import '@/static/styles/index.scss';
</style>